/**
 * @generated SignedSource<<6b92a995d0616042c10c3016925f3ee0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserPrimaryPhotoNew_user$data = {
  readonly defaultAvatarUrl: string;
  readonly emailMd5: string | null | undefined;
  readonly firstName: string;
  readonly lastName: string;
  readonly primaryPhoto: {
    readonly transformUrl: string;
  } | null | undefined;
  readonly rowId: string;
  readonly " $fragmentType": "UserPrimaryPhotoNew_user";
};
export type UserPrimaryPhotoNew_user$key = {
  readonly " $data"?: UserPrimaryPhotoNew_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserPrimaryPhotoNew_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "dpr",
  "variableName": "dpr"
},
v1 = {
  "kind": "Literal",
  "name": "fo",
  "value": "auto"
},
v2 = {
  "kind": "Variable",
  "name": "h",
  "variableName": "imageSize"
},
v3 = {
  "kind": "Variable",
  "name": "w",
  "variableName": "imageSize"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 3,
      "kind": "LocalArgument",
      "name": "dpr"
    },
    {
      "defaultValue": 100,
      "kind": "LocalArgument",
      "name": "imageSize"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserPrimaryPhotoNew_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailMd5",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "primaryPhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "fields": [
                (v0/*: any*/),
                {
                  "kind": "Literal",
                  "name": "fit",
                  "value": "cover"
                },
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/)
              ],
              "kind": "ObjectValue",
              "name": "transform"
            }
          ],
          "kind": "ScalarField",
          "name": "transformUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "fields": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "transform"
        }
      ],
      "kind": "ScalarField",
      "name": "defaultAvatarUrl",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "cc48e14ebc69a56c932253c738133406";

export default node;
